import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
   root: {
      display: 'visible',
      // width: '4rem',
      // marginLeft: (props) => {
      //    return theme.spacing(Number(props.marginLeft));
      // },
      color: 'black',
      [theme.breakpoints.down('sm')]: {
         display: 'hidden',
      },
   },
}));

export { useStyles };
